var _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCyprus = function SvgCyprus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Cyprus_svg__a",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Cyprus_svg__b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.6,
    cy: 100.3,
    r: 97.8,
    className: "Cyprus_svg__f",
    transform: "rotate(-81 100 100)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Cyprus_svg__d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 100.3,
    r: 96.8,
    className: "Cyprus_svg__f",
    transform: "rotate(-45 320 100)"
  })), /*#__PURE__*/React.createElement("style", null, ".Cyprus_svg__f,.Cyprus_svg__k{stroke-width:0}.Cyprus_svg__f{fill:none}.Cyprus_svg__k{fill:#fff}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.6,
    cy: 100.3,
    r: 97.8,
    fill: "none",
    stroke: "#a5a7aa",
    strokeMiterlimit: 10,
    strokeWidth: 1.8,
    transform: "rotate(-45 100 100)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Cyprus_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cyprus_svg__c",
    d: "M-47 3h293v196H-47z",
    className: "Cyprus_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2a73c",
    strokeWidth: 0,
    d: "M67 75c-13-7-15 4-16 6-1 3-4 3-4 3h-7c-2 0-4-5-4-5l1 6 1 4 3 1-1 4 1 2v2l3 1 1 4 1 1 4 6h6l2 2c1 1 3 0 7 4 2 1 1-1 1-1l5-2 2-1 2 1 4 4 1 4c4 2 4-1 4-2v-3l1-2c0-2 3-2 5-3l5-2 3 1 2 2 1-2 2-1h3l2-2 3-1 1-1h3l3-3 5-1c-1-9 3-11 3-11h3l1-1 2-1v1l3 1 4 2 3-5 3 1 2 1 3 1 1-1v-3l-2-2-2-2s0-3-4-6c-4-2-1-10-1-10l2-2 6-1 1-2 1-1 1-1 2-2 2-3h1l2-3h3l2-2 2-1 1-2h3l1-1 1-3h3v-2h4v-3l2-1 1-4s-2-1-3 1l-2 3s-6-2-6 0l-5 6h-4l-2 3h-4l-2 3h-5s0 2-5 4c-5 1-8 4-8 4h-6s-3 4-7 4l-5 2c-2-1-4 1-4 1h-11l-5-2-9-1c-5 0-11-5-11-5l-1 6 2 3s-1 17-13 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78a640",
    strokeWidth: 0,
    d: "M154 127c0-1 5-4 4-10-2 2-4 3-6 8 0 1 1 2 2 1Zm-12 9c0 1 1 2 2 1 6-3 7-8 7-8l-6 3-3 3Zm-11 10c6 0 9-7 9-7-3 1-6 1-10 5l1 2Zm0 0Zm-17 4c-1 1 0 2 1 2 8 1 11-5 11-5-5 0-10 2-12 3Zm41-23c-2 1-5 3-2 4 5-1 8-6 8-6l-6 2Zm-12 15c6 0 9-5 9-5-9-1-14 6-9 5Zm-16 7c-1 0-1 2 1 2l4 1 8-3h-1c-4-2-9-2-12 0Zm-16 5c-1 0-2 1-1 2l8 2 6-1c-4-3-8-3-13-3Zm11-1 2 1c2 0 3-1 2-2s-4-1-4 1Zm18-10c-2 1-2 3 0 3s3-1 2-2l-2-1Zm12-10c-2 0-2 2-1 2l3-2-2-1Zm-3-5 2-4c1-3 0-5-1-6 0 1-2 3-2 8l1 2Zm-9 9 2-3v-6s-4 3-4 8c0 1 1 2 2 1Zm-14 8c6-3 5-9 5-9l-5 4-2 4 1 1h1Zm-15 5c7-2 8-9 8-9-4 2-6 2-10 7-1 1 1 3 2 2Zm11-5v-2c-1 0-3 2-2 3l2-1Zm14-7c1-2 0-3-1-3s-2 3-1 4l2-1Zm9-8c2 0 3-3 1-4-2 0-2 4-1 4Zm-43 28 3 3 4-1-5-4-2 1Zm10-6v-1s-5 0-11 4v2c5-4 11-4 11-5Zm-64-25c1 0 2-1 1-2-2-5-5-7-6-8 0 1 0 4 2 7l3 3Zm3 2s1 7 7 9c1 0 2-1 1-2 0 0-5-6-8-7Zm11 10c0 1 1 4 4 6l5 2c4 0-2-7-9-8h-1Zm13 8v1c5 5 12 4 12 4v-2c-5-3-7-3-12-3Zm-26-16h1l-1-2-8-4c0 1 2 5 7 6h1Zm12 10-1-1c-6-3-7-3-11-3 1 1 5 6 11 5v-1Zm13 8c-6-2-11 0-12 0l8 3 5-1-1-2Zm16 5c-8-1-13 3-13 3 7 3 16 0 15-2l-2-1Zm-11-1c0-1-3-2-4-1-2 3 5 3 4 1Zm-18-9c-3-1-3 2 1 2s2-2-1-3Zm-11-11c-3-2-3 2 0 2s2-1 0-2Zm3-6c1-5-2-8-2-8l-1 5c1 5 3 5 3 3Zm11 9c-1-5-5-8-5-8s-1 3 1 6c2 5 4 4 4 2Zm12 10c1 0 2-1 1-2-2-6-6-8-7-8l2 7 4 3Zm17 2-4-4-6-3v1c1 7 11 11 9 6Zm-11-2c1-1-1-3-2-3s-2 1-1 2 2 2 3 1Zm-14-7c1-1-1-4-2-3-2 0 0 4 2 3Zm-12-9c2-1 1-4-1-3-1 0 0 4 1 3Zm37 30 4 1 4-4v-2l-8 5Zm5-5 2-1-10-3-1 2h1l8 2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.6,
    cy: 100.3,
    r: 97.8,
    className: "Cyprus_svg__f",
    transform: "rotate(-81 100 100)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Cyprus_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2f4ca0",
    strokeWidth: 0,
    d: "M141 4h290v194H141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed500",
    strokeWidth: 0,
    d: "M195 4h193v193L195 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cyprus_svg__e",
    d: "M153 4h14l4 12-11-8-11 8 4-12Z",
    className: "Cyprus_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191 28 11-8h-14l-4-13-4 13h-13l10 8-4 12 11-7 11 7-4-12zm24 24 11-8h-14l-4-13-4 13h-13l11 8-4 13 10-8 11 8-4-13z",
    className: "Cyprus_svg__k"
  }))));
};
export default SvgCyprus;